import { useState } from "react";
import { useTranslation } from "react-i18next";

const DescriptionWithReadMore: React.FunctionComponent<{ text: any }> = (props) => {

    const [isExpanded, setIsExpanded] = useState(false);
    const shouldTruncate = props.text.length > 400;
    const displayText = isExpanded || !shouldTruncate ? props.text : props.text.slice(0, 400) + "…";
    const { t } = useTranslation();

    return (
        <div className=" card-form mb-4 padd-15 height-affich">
            <p
                className="para-14 bold-500 color-727272 line-height-23"
                style={{ whiteSpace: "pre-wrap" }}
                dir="auto"
            >
                {displayText}
                {shouldTruncate && (
                    <span
                        onClick={() => setIsExpanded(!isExpanded)}
                        className="cursor-p color-4F52C1 marg-left-10 bold-600"

                    >
                        {isExpanded ? `${t("listingCreation.readLess")}` : `${t("listingCreation.readMore")}`}
                    </span>
                )}
            </p>
        </div>
    );

}

export default DescriptionWithReadMore;
